//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
// User Guid Link
//

// Libs
import React from 'react';
import PropTypes from 'prop-types';

// Prism-react UI Components
import { FlexLayout, Link } from '@nutanix-ui/prism-reactjs';
import getI18nService from '../i18n/I18n';

const i18n = getI18nService();

export default class UserGuideLink extends React.Component {
    constructor(props) {
        super(props);
        const baseURL = 'https://portal.nutanix.com/#/page/prismDocs?';
        const args = {
            software_type: 'Prism',
            software_version: props.version || '5.18',
            prism_id: 'pages/overview/login',
        };

        const keys = Object.keys(args);
        const parars = keys.reduce((acc, cur, idx) => {
            return idx ? `${acc}&${cur}=${args[cur]}` : `${cur}=${args[cur]}`;
        }, '');

        this.state = {
            url: baseURL + parars,
        };
    }

    render() {
        const { url } = this.state;

        return (
            <FlexLayout
                id="userguide-link"
                alignItems="center"
                justifyContent="center"
                data-item-spacing="20px"
            >
                <Link type="info" target="_blank" href={url}>
                    {i18n.t('HomePage.userGuideHelp')}
                </Link>
            </FlexLayout>
        );
    }
}

UserGuideLink.propTypes = {
    version: PropTypes.string,
};
